import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JsonPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-show-environment',
  standalone: true,
  imports: [
    JsonPipe,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './show-environment.component.html',
  styleUrl: './show-environment.component.scss'
})
export class ShowEnvironmentComponent {

  constructor(public dialogRef: MatDialogRef<ShowEnvironmentComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  save(data: any) {
    console.log(data);
  }

  close() {
    this.dialogRef.close()
  }
}
